import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import React from "react";
import theme from "Theme/AppTheme";
import App from "./AdminApp";

export default function AdminAppContainer() {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </StyledEngineProvider>
    );
}
